// ProviderCardListingSkeleton.tsx
import React from 'react';

export const ProviderCardListingSkeleton = ({ count = 4 }: { count?: number }) => {
  return (
    <div className="mt-10 animate-pulse">
      <ul className="mt-4 space-y-4">
        {Array.from({ length: count }).map((_, index) => (
          <li key={index} className="py-[30px] flex flex-col lg:flex-row border-b-2 border-gray-50">
            {/* Left Content Side */}
            <div className="flex-grow">
              {/* Doctor Name Placeholder */}
              <div className="h-7 md:h-8 bg-slate-200 rounded w-2/3 mb-4" />

              {/* Specialties Placeholder */}
              <div className="h-5 bg-slate-200 rounded w-1/2 my-5" />

              {/* Mobile Profile Photo Placeholder (Hidden on Desktop) */}
              <div className="block lg:hidden w-[100px] h-[125px] md:w-[270px] md:h-[270px] bg-slate-100 rounded-[8px] mb-8" />

              {/* Reviews Section Placeholder */}
              <div className="h-5 bg-slate-200 rounded w-1/3 mb-4" />

              {/* Accepting Patients Badge Placeholder */}
              <div className="h-[37px] w-48 bg-slate-100 rounded-[6px] lg:mt-16 mt-4 mb-12" />
            </div>

            {/* Right Side - Desktop Profile Photo Placeholder */}
            <div className="flex gap-x-24">
              <div className="hidden lg:block w-[160px] h-[200px] bg-slate-100 rounded-[8px] shrink-0" />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
